import { render } from "./dispatch-parameters.vue?vue&type=template&id=17b32968&scoped=true"
import script from "./dispatch-parameters.vue?vue&type=script&lang=js"
export * from "./dispatch-parameters.vue?vue&type=script&lang=js"

import "./dispatch-parameters.vue?vue&type=style&index=0&id=17b32968&scoped=true&lang=css"
import "./dispatch-parameters.vue?vue&type=style&index=1&id=17b32968&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b32968"]])

export default __exports__